import LegalPageShell from "@/components/LegalPageShell";

const SECTIONS = [
  {
    number: 1,
    title: "Acceptance of Terms",
    paragraphs: ["By creating an account or using RootLyst, you agree to comply with these Terms and our Privacy Policy."],
  },
  {
    number: 2,
    title: "Our Services",
    paragraphs: ["RootLyst provides software for:"],
    bullets: [
      "Patient Management",
      "Appointment Scheduling",
      "Medical Records",
      "AI Report Analysis",
      "AI Insights",
      "AI Patient Timeline",
      "AI Consultation Assistance",
      "Digital Prescriptions",
      "Clinic Management",
    ],
  },
  {
    title: "",
    paragraphs: ["RootLyst is a technology platform and does not provide medical advice, diagnosis, or treatment. All clinical decisions remain the responsibility of the treating healthcare professional."],
  },
  {
    number: 3,
    title: "User Responsibilities",
    paragraphs: ["You agree to:"],
    bullets: [
      "Provide accurate information.",
      "Keep your account credentials secure.",
      "Use the platform only for lawful healthcare purposes.",
      "Maintain patient confidentiality.",
      "Comply with applicable healthcare and data protection laws.",
    ],
  },
  {
    number: 4,
    title: "AI Disclaimer",
    paragraphs: ["AI-generated analyses, summaries, and recommendations are provided for clinical assistance only. Doctors must independently review all AI outputs before making medical decisions."],
  },
  {
    number: 5,
    title: "Subscription & Payments",
    bullets: [
      "Access may require an active subscription.",
      "Subscription fees are billed as per the selected plan.",
      "Failure to pay may result in suspension or termination of services.",
    ],
  },
  {
    number: 6,
    title: "Intellectual Property",
    paragraphs: ["All software, logos, branding, designs, and content of RootLyst are owned by RootLyst and may not be copied, modified, or redistributed without written permission."],
  },
  {
    number: 7,
    title: "Limitation of Liability",
    paragraphs: [
      "RootLyst is not liable for medical decisions, treatment outcomes, data entered incorrectly by users, or service interruptions beyond our reasonable control. Users are responsible for verifying all clinical information before use.",
    ],
  },
  {
    number: 8,
    title: "Account Termination",
    paragraphs: ["We reserve the right to suspend or terminate accounts that violate these Terms or misuse the platform."],
  },
  {
    number: 9,
    title: "Changes to Terms",
    paragraphs: ["We may update these Terms from time to time. Continued use of the platform constitutes acceptance of the updated Terms."],
  },
  {
    number: 10,
    title: "Governing Law",
    paragraphs: ["These Terms are governed by the laws of India, and any disputes shall be subject to the jurisdiction of the appropriate courts in India."],
  },
  {
    number: 11,
    title: "Contact Us",
    paragraphs: ["For any questions regarding these Terms & Conditions:", "RootLyst Support", "Email: contact@rootlyst.com"],
  },
];

export default function TermsPage() {
  return (
    <LegalPageShell
      testId="terms-page"
      title="Terms & Conditions"
      effectiveDate="18/07/2026"
      lastUpdated="18/07/2026"
      intro="Welcome to RootLyst, an AI-powered clinic management platform. By accessing or using our platform, you agree to these Terms & Conditions."
      sections={SECTIONS}
    />
  );
}
